import { OrderedSet }             from 'immutable';
import { combineReducers } from 'redux-immutable';
import { handleActions }   from 'redux-actions';
import {
  addServiceToShortlist,
  removeServiceFromShortlist
}                          from '../actions/localShortlist';


const name = handleActions({}, 'My Shortlist');

const serviceIds = handleActions(
  {

    [addServiceToShortlist](state, {payload: {serviceId}}) {

      if (state.has(serviceId)) {

        return state;

      }

      return state.add(serviceId);

    },

    [removeServiceFromShortlist](state, {payload: {serviceId}}) {

      if (!state.has(serviceId)) {

        return state;

      }

      return state.delete(serviceId);

    },

  },

  OrderedSet()
);


export default combineReducers({name, serviceIds});


// WEBPACK FOOTER //
// ./src/reducers/localShortlist.js